const XS = 0;
const SM = 600;
const MD = 980;
const LG = 1280;
const XL = 1980;

export { XS, SM, MD, LG, XL };
